import { Stack, Typography } from '@mui/material';
import { SUGGESTED_REPORTS_CONFIG } from './config/suggested-reports-config';
import { SuggestedReportsSectionItem } from './reports-page-components/suggested-reports-section-item/SuggestedReportsSectionItem';
import { ReportsPageBanner } from './reports-page-components/banner/Banner';

export const ReportsMainPageV2 = () => {
  return (
    <Stack
      sx={{
        gap: 4,
        padding: 2,
        paddingTop: 0
      }}>
      <Typography sx={{
        fontSize: "24px"
      }}>Reports</Typography>
      <ReportsPageBanner />
      <Stack sx={{
        paddingLeft: 1.5
      }}>
        <Stack
          direction="row"
          sx={{
            gap: "70px",
            flexWrap: "wrap"
          }}>
          {SUGGESTED_REPORTS_CONFIG.map((report) => (
            <SuggestedReportsSectionItem key={report.title} data={report} />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
